var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{attrs:{"cols":"12"}},[_c('horiba-data-table',{attrs:{"list-route":_vm.listRoute,"columns":_vm.columns}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }